import React, { Component } from 'react';
import Spinner from '../Spinner/Spinner';
import classname from  './Backdrop.module.css';
import { isMobileOnly } from "react-device-detect";


class backdrop extends Component {
    componentWillUnmount(){
        document.body.classList.remove('blockScroll');
    }

    render(){
        document.body.classList.add('blockScroll');
        let backdropCoponent = null;
        if (this.props.showSpinner){
            backdropCoponent = <div className={classname.BackdropSpinner} 
            style={{
                height: isMobileOnly ? window.screen.height : '',
                width: isMobileOnly ? window.screen.width: ''
            }}> <Spinner /> </div>
        }
        if (this.props.showBack && !this.props.showSpinner){
            backdropCoponent = (
                <div className={classname.Backdrop}> {this.props.children} </div>
            )
        }
        return (
            backdropCoponent
        );
    }
}

export default backdrop;